import { render, staticRenderFns } from "./ImagesUploadorder.vue?vue&type=template&id=52c87bee&scoped=true"
import script from "./ImagesUploadorder.vue?vue&type=script&lang=ts"
export * from "./ImagesUploadorder.vue?vue&type=script&lang=ts"
import style0 from "./ImagesUploadorder.vue?vue&type=style&index=0&id=52c87bee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c87bee",
  null
  
)

export default component.exports